import { render, staticRenderFns } from "./BulkImportResult.vue?vue&type=template&id=b9366e06&scoped=true"
import script from "./BulkImportResult.vue?vue&type=script&lang=js"
export * from "./BulkImportResult.vue?vue&type=script&lang=js"
import style0 from "./BulkImportResult.vue?vue&type=style&index=0&id=b9366e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9366e06",
  null
  
)

export default component.exports